import {CustomSettingsFragment} from '../../../../gql/graphql';

export class SettingsModel {
  public lockGiftCard: boolean;
  public lockCouponCode: boolean;
  public policyAgreementCheckboxDisabled: boolean;
  public manualPaymentDisabled: boolean;

  constructor(params: SettingsModel) {
    this.lockGiftCard = params.lockGiftCard;
    this.lockCouponCode = params.lockCouponCode;
    this.policyAgreementCheckboxDisabled = params.policyAgreementCheckboxDisabled;
    this.manualPaymentDisabled = params.manualPaymentDisabled;
  }

  public static fromCheckoutV1(settings?: CustomSettingsFragment | null) {
    if (!settings) {
      return undefined;
    }
    return new SettingsModel({
      lockGiftCard: settings?.lockGiftCard ?? false,
      lockCouponCode: settings?.lockCouponCode ?? false,
      policyAgreementCheckboxDisabled: settings?.disabledPolicyAgreementCheckbox ?? false,
      manualPaymentDisabled: settings?.disabledManualPayment ?? false,
    });
  }
}
